angular.module('hjApp.account', [
    'hjApp.api',
    'hjApp.logging',
    'hjApp.ui',
    'hjApp.user',
    'hjApp.utils',
    'hjApp.tracking',
    'ui.router'
]);
